import LabelStatus from 'components/ui/labelStatus';
import { Skeleton } from 'components/ui/skeleton';

export const MafFormDemonstration = () => (
  <div className='border-border-base w-min border-collapse overflow-hidden rounded-(--component-table-border-radius) rounded-tr-none rounded-br-none border border-r-0'>
    <table>
      <thead>
        <tr className='border-border-base border-b'>
          <th className='text-xs-semi-bold text-text-secondary bg-background-secondary border-border-base h-10 overflow-hidden border-r px-2 align-middle whitespace-nowrap'>
            ACTION
          </th>
          <th className='text-xs-semi-bold text-text-secondary bg-background-secondary border-border-base h-10 overflow-hidden border-r px-2 align-middle whitespace-nowrap'>
            NAME
          </th>
          <th className='text-xs-semi-bold text-text-secondary bg-background-secondary border-border-base h-10 overflow-hidden border-r px-2 align-middle whitespace-nowrap'>
            STATUS
          </th>
          <th className='text-xs-semi-bold text-text-secondary bg-background-secondary h-10 overflow-hidden px-2 align-middle whitespace-nowrap'>
            CREATED
          </th>
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: 4 }).map((_, i) => (
          <tr key={i}>
            <td className='h-10 overflow-hidden px-2 align-middle whitespace-nowrap'>
              <div className='text-brand-main'>View</div>
            </td>
            <td className='h-10 overflow-hidden px-2 align-middle whitespace-nowrap'>
              <Skeleton width='45px' height='10px' />
            </td>
            <td className='h-10 overflow-hidden px-2 align-middle whitespace-nowrap'>
              <LabelStatus status='warning' text='in review' />
            </td>
            <td className='h-10 overflow-hidden px-2 align-middle whitespace-nowrap'>
              <Skeleton width='45px' height='10px' />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
